import { render, staticRenderFns } from "./m_vlog_rule.vue?vue&type=template&id=10103574&scoped=true&"
import script from "./m_vlog_rule.vue?vue&type=script&lang=js&"
export * from "./m_vlog_rule.vue?vue&type=script&lang=js&"
import style0 from "./m_vlog_rule.vue?vue&type=style&index=0&id=10103574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10103574",
  null
  
)

export default component.exports